export default __webpack_public_path__ + "static/media/FSMeridian-Light.1079ed9c.woff";